import React from "react";
import { useDispatch, useSelector } from "react-redux";
import TemplateAccord from "../../../common/TemplateUtils/TemplateAccord";
import MainCategory from "../EditSection/MainCategory";
import MainTemplateModal from "../TemplateModals/MainTemplateModal";
import NewSiteDetail from "../TemplateModals/NewSiteDetail";
import TemplateAdd from "../../../common/TemplateUtils/TemplateAdd";
import uuid from "react-uuid";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { filterObjectsUptoCategory, timestamp } from "../../../utils/services";
import { AnimatePresence, motion } from "framer-motion";
import InlineIntroductoryText from "../../../common/TemplateUtils/InlineIntroductoryText";
import { updateCategoryData } from "../../../store/action";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

const CategoryLists = (props) => {
  const {
    CategoryList,
    setAllCategoryList,
    id,
    disableDnD,
    category,
    duplicateCategoryId,
    setDuplicateCategoryId,
    isInspection,
    AllCategoryList,
    updateTemplate,
    checkActiveFocus,
    skeletonLoad,
    setSkeletonLoad,
    isFocused,
    renamingId,
    duplicateIndex,
    renId,
    isChanged,
    activeRename,
    TriggerClick,
    outsideClick,
    LoadList,
    dragHandleProps,
    categoryActive,
    resetKey,
    onCategoryMenuOpenChange,
    anyMenuOpen,
  } = props;

  const categorydata = category?.lines;
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.templates)?.categoryList;
  // Accordtion
  const [expanded, setExpanded] = React.useState("");
  const [accordOpen, setAccordOpen] = React.useState(false);

  React.useEffect(() => {
    setExpanded("");
    setAccordOpen(false);
  }, [resetKey]);
  const [menu, setMenu] = React.useState(false);
  const [ActiveId, setActiveId] = React.useState(null);

  // Report whether ANY three-dot menu belonging to this category — its own,
  // or one of its lines' — is currently open (this includes the "Assign
  // Color" list and its scrollbar). InspectionDetails.js uses this to
  // disable dragging for every category while it's true, not just this one:
  // interacting with a menu's color list must never be interpreted as a
  // drag gesture, on this category, its lines, or any other category.
  React.useEffect(() => {
    onCategoryMenuOpenChange && onCategoryMenuOpenChange(menu, category?.uuid);
  }, [menu, category?.uuid, onCategoryMenuOpenChange]);
  const [catoutput, setCatOutput] = React.useState([]);
  const [duplicateLineId, setduplicateLineId] = React.useState(false);
  const [lineLoader, setlineLoader] = React.useState(false);

  React.useEffect(() => {
    if (categorydata !== undefined && categorydata !== null && categorydata.length > 0) {
      setCatOutput((prev) => {
        const newCategoryList = [...categorydata];
        return newCategoryList;
      });
    } else {
      setCatOutput([]);
    }
  }, [categorydata]);

  const uuids1 = uuid();
  const uuids2 = uuid();
  const uuids3 = uuid();
  const uuids4 = uuid();
  const uuids5 = uuid();
  const uuids6 = uuid();
  const uuids7 = uuid();

  // Create site

  const [createNewSite, setCreateNewSite] = React.useState(false);
  const [createNewSite1, setCreateNewSite1] = React.useState(false);

  const [siteName, setSiteName] = React.useState("");
  const [siteId, setSiteId] = React.useState(null);
  const HandleCreateSite = () => setCreateNewSite(!createNewSite);

  const stopActive = (event) => event.stopPropagation();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : "categories");
    setAccordOpen(!accordOpen);
  };

  const OpenMenu = (event, id) => {
    stopActive(event);
    setMenu(!menu);
    setActiveId(id);
  };

  const CloseMenu = (event) => {
    stopActive(event);
    setMenu(!menu);
  };

  const CreateBlankLine = (id) => {
    const catList = AllCategoryList?.template?.categories;
    const targetCatId = id || category?.category_id || category?.id || category?.uuid;
    const categoriesData = Array.isArray(catList)
      ? catList.findIndex(
          (cat) =>
            (cat?.category_id && cat?.category_id === targetCatId) ||
            (cat?.id && cat?.id === targetCatId) ||
            (cat?.uuid && cat?.uuid === targetCatId)
        )
      : -1;

    if (categoriesData === -1) return;

    const currentLines = catList[categoriesData]?.lines || [];
    currentLines.forEach((line, index) => {
      if (line.order === undefined || line.order === null || isNaN(Number(line.order))) {
        line.order = index + 1;
      }
    });

    const validOrders = currentLines
      .map((item) => Number(item?.order))
      .filter((ord) => !isNaN(ord) && isFinite(ord));
    const highestOrder = validOrders.length > 0 ? Math.max(...validOrders) : 0;
    const newOrder = currentLines.length === 0 ? 1 : highestOrder + 1;

    const datas = {
      id: uuids1,
      line_id: uuids1 /*uuid */,
      uuid: uuids1,
      prompt: "Untitled",
      comments: [],
      defaultRating_id: null,
      defaultRating_ids: [],
      line_rating_data: [],
      order: newOrder,
      default_location: null,
      updated_at: timestamp(),
      is_deleted: 0,
      optional: 0,
      line_input_controls: [],
      is_printable: catList[categoriesData]?.is_printable,
    };

    if (catList[categoriesData]?.lines) {
      catList[categoriesData].lines.push(datas);
    } else {
      catList[categoriesData].lines = [datas];
    }

    setCatOutput(catList[categoriesData]?.lines);
    filterObjectsUptoCategory(catList, targetCatId, dispatch, categories);
    updateTemplate("noToast");
    setAllCategoryList((prev) => {
      const newCategoryList = { ...AllCategoryList };
      newCategoryList.template.categories = catList;
      newCategoryList.template.categories.updated_at = timestamp();
      return newCategoryList;
    });
  };

  const HandleCreateSite1 = () => {
    setCreateNewSite1(!createNewSite1);
    setSiteName("");
    setSiteId(null);
  };

  const AddSiteDetaill = () => {
    const addSite = AllCategoryList.template.categories;
    let insp = addSite.find((insp) => insp.is_inspection_details === 1);
    const newSiteObj =
      siteId.id === 1
        ? {
          type: "CheckBox",
          uuid: uuids1,
          prompt: siteName,
          line_id: uuids2,
          comments: [],
          created_at: timestamp(),
          is_deleted: 0,
          updated_at: timestamp(),
          default_location: null,
          line_input_controls: [
            {
              type: "CheckBox",
              uuid: uuids6,
              prompt: siteName,
              data: [],
              values: [
                {
                  uuid: uuids3,
                  value: "check 1",
                  updated_at: timestamp(),
                  is_selected: false,
                  is_deleted: 0,
                  order: 1,
                },
                {
                  uuid: uuids4,
                  value: "check 2",
                  updated_at: timestamp(),
                  is_selected: false,
                  is_deleted: 0,
                  order: 2,
                },
                {
                  uuid: uuids5,
                  value: "check 3",
                  updated_at: timestamp(),
                  is_selected: false,
                  is_deleted: 0,
                  order: 3,
                },
              ],
              created_at: timestamp(),
              updated_at: timestamp(),
              line_input_control_id: uuids7,
            },
          ],
        }
        : siteId.id === 2
          ? {
            type: "TextBox",
            uuid: uuids1,
            prompt: siteName,
            line_id: uuids2,
            comments: [],
            created_at: timestamp(),
            is_deleted: 0,
            updated_at: timestamp(),
            default_location: null,
            line_input_controls: [
              {
                type: "TextBox",
                uuid: uuids6,
                prompt: siteName,
                data: "",

                values: [],
                created_at: timestamp(),
                updated_at: timestamp(),
                line_input_control_id: uuids7,
              },
            ],
          }
          : siteId.id === 3 && {
            type: "Temperature",
            uuid: uuids1,
            prompt: siteName,
            line_id: uuids2,
            comments: [],
            created_at: timestamp(),
            is_deleted: 0,
            updated_at: timestamp(),
            default_location: null,
            line_input_controls: [
              {
                type: "Temperature",
                uuid: uuids6,
                prompt: siteName,
                data: { type: null, value: null },
                values: [{ type: null, value: null }],
                created_at: timestamp(),
                updated_at: timestamp(),
                line_input_control_id: uuids7,
              },
            ],
          };
    // every item in the inspection details object has an order of 1
    newSiteObj.order = insp.lines.length + 1;
    newSiteObj.is_inspection_detail_line = true;
    newSiteObj.optional = 0;
    insp.lines.push(newSiteObj);
    insp.lines.forEach((x, i) => {
      x.order = i + 1;
      x.updated_at = timestamp();
      return x;
    });
    let newUpdatedCategoryData = AllCategoryList;
    newUpdatedCategoryData.template.categories[0] = insp;
    dispatch(updateCategoryData([insp]));
    updateTemplate("noToast");
    setAllCategoryList((prev) => {
      const newCategoryList = { ...AllCategoryList };
      newCategoryList.template.categories[0] = insp;
      newCategoryList.template.categories.updated_at = timestamp();
      return newCategoryList;
    });
    setCatOutput(insp.lines);
    HandleCreateSite1();
  };

  const reorder = (data, startIndex, endIndex) => {
    const result = Array.from(data);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;

    // 1. Reorder dragged items
    const reorderedItems = reorder([...catoutput], result.source.index, result.destination.index).map((item, index) => ({
      ...item,
      order: index + 1,
      updated_at: timestamp(),
    }));
    setCatOutput(reorderedItems);
    const updatedAllCategoryList = JSON.parse(JSON.stringify(AllCategoryList));
    const updatedCategories = updatedAllCategoryList.template.categories;
    const catIndex = updatedCategories.findIndex((c) => c.category_id === category.category_id || c.uuid === category.uuid);
    if (catIndex === -1) return;
    updatedCategories[catIndex].lines = reorderedItems;
    updatedCategories[catIndex].updated_at = timestamp();
    setAllCategoryList({
      ...updatedAllCategoryList,
      template: {
        ...updatedAllCategoryList.template,
        categories: updatedCategories,
        updated_at: timestamp(),
      },
    });
    dispatch(updateCategoryData(updatedCategories));
    updateTemplate("noToast");
  };

  const [actives, setActives] = React.useState(false);
  const [ids, setIds] = React.useState("");
  const [isActive, setIsActive] = React.useState("");

  const disableDnD2 = (isOpen, id) => {
    setActives(isOpen);
    setIds(id);
  };

  return (
    <>
      <TemplateAccord
        dragHandleProps={dragHandleProps}
        disableDnD={(isOpen, id) => disableDnD(isOpen, id)}
        isFocused={isFocused}
        checkActiveFocus={checkActiveFocus}
        expanded={expanded}
        handleChange={(panel) => handleChange(panel)}
        accordOpen={accordOpen}
        item={category}
        selectedID={category?.uuid}
        categoryId={category?.id}
        skeletonLoad={skeletonLoad}
        setSkeletonLoad={setSkeletonLoad}
        duplicateIndex={duplicateIndex}
        linedata={category}
        AllCategoryList={AllCategoryList}
        setAllCategoryList={setAllCategoryList}
        isInspection={isInspection}
        duplicateCategoryId={duplicateCategoryId}
        setDuplicateCategoryId={setDuplicateCategoryId}
        from={`CATEGORY_${category?.id}`}
        isChanged={isChanged}
        renId={renId}
        renamingId={(id) => renamingId(id)}
        activeRename={activeRename}
        TriggerClick={TriggerClick}
        outsideClick={outsideClick}
        updateTemplate={updateTemplate}
        HeaderTitle={category?.prompt}
        LoadList={LoadList}
        templateId={category?.template_id}
        categoryActive={categoryActive}
        innerTemplate={
          <>
            {catoutput ? (
              <>
                {!isInspection && (
                  <InlineIntroductoryText
                    from={`SUBCATEGORY_${category.category_id}`}
                    isActive={isActive}
                    setIsActive={setIsActive}
                    disableDnD={disableDnD}
                    selectedID={category.category_id}
                    accordOpen={accordOpen}
                    AllCategoryList={AllCategoryList}
                    categoryId={category.category_id}
                    categoryUuid={category?.uuid}
                    updateTemplate={updateTemplate}
                    setAllCategoryList={setAllCategoryList}
                  />
                )}
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="CategoryLists">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        <AnimatePresence>
                          {catoutput?.map((items, index) => {
                            return items?.is_deleted ? null : (
                              <motion.div
                                key={items?.line_id}
                                onAnimationStart={() => setlineLoader(false)}
                                initial={{ opacity: 0, scale: 1, y: -50 }}
                                animate={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ duration: 0.5 }}
                                exit={{ opacity: 0, scale: 1, x: -50 }}>
                                <Draggable
                                  draggableId={String(items?.line_id)}
                                  isDragDisabled={(actives && items?.line_id === ids) || menu || anyMenuOpen}
                                  key={items?.line_id}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div ref={provided.innerRef} {...provided.draggableProps}>
                                      <TemplateAccord
                                        disableDnD={(isOpen, id) => disableDnD2(isOpen, id)}
                                        dragHandleProps={provided.dragHandleProps}
                                        expanded={expanded}
                                        handleChange={(panel) => handleChange(panel)}
                                        accordOpen={accordOpen}
                                        selectedID={items?.line_id}
                                        lineIndex={index}
                                        AllCategoryList={AllCategoryList}
                                        setAllCategoryList={setAllCategoryList}
                                        checkActiveFocus={checkActiveFocus}
                                        setduplicateLineId={setduplicateLineId}
                                        duplicateLineId={duplicateLineId}
                                        isChanged={isChanged}
                                        setlineLoader={setlineLoader}
                                        renId={renId}
                                        isInspectionLines={items?.is_inspection_detail_line}
                                        item={items}
                                        linedata={items}
                                        renamingId={(id) => renamingId(id)}
                                        activeRename={activeRename}
                                        from={`SUBCATEGORY_${items?.line_id}_${category?.category_id}`}
                                        HeaderTitle={items?.prompt}
                                        TriggerClick={TriggerClick}
                                        outsideClick={outsideClick}
                                        updateTemplate={updateTemplate}
                                        LoadList={LoadList}
                                        categoryId={category?.category_id}
                                        isInspection={isInspection}
                                        innerTemplate={
                                          <MainCategory
                                            renId={renId}
                                            checkActiveFocus={checkActiveFocus}
                                            isChanged={isChanged}
                                            renamingId={(id) => renamingId(id)}
                                            updateTemplate={updateTemplate}
                                            TriggerClick={TriggerClick}
                                            activeRename={activeRename}
                                            selectedID={items?.line_id}
                                            lineItem={items}
                                            isInspection={isInspection}
                                            categoryId={category?.category_id}
                                            categoryName={category?.prompt}
                                            lineId={items?.line_id}
                                            categoryUuid={category?.uuid}
                                            AllCategoryList={AllCategoryList}
                                            setAllCategoryList={setAllCategoryList}
                                          />
                                        }
                                        actions={{
                                          CloseMenu: (event) => CloseMenu(event),
                                          stopActive: (event) => stopActive(event),
                                          OpenMenu: (event, id) => OpenMenu(event, id),
                                          ActiveId,
                                          menu,
                                        }}
                                      />
                                    </div>
                                  )}
                                </Draggable>
                                {lineLoader && index === duplicateLineId - 1 ? (
                                  <motion.div initial={{ opacity: 0, scale: 1, y: -50 }} animate={{ opacity: 1, scale: 1, y: 0 }} transition={{ duration: 0.5 }}>
                                    <Skeleton sx={{ height: "69px", marginTop: "-15px" }} />
                                  </motion.div>
                                ) : (
                                  ""
                                )}
                              </motion.div>
                            );
                          })}
                        </AnimatePresence>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </>
            ) : (
              <Stack spacing={1}>
                <Skeleton variant="rectangular" height={50} sx={{ backgroundColor: "rgba(0, 0, 0, 0.05)", "&::after": { backgroundColor: "rgba(0, 0, 0, 0.1)" } }} />
              </Stack>
            )}
            <TemplateAdd
              from={"subcat"}
              HandleCreateSite={() => (isInspection === 1 ? HandleCreateSite1() : CreateBlankLine(category?.category_id || category?.id || category?.uuid))}
              name={isInspection === 1 ? "Add New" : "Add line"}
            />
          </>
        }
        actions={{
          CloseMenu: (event) => CloseMenu(event),
          stopActive: (event) => stopActive(event),
          OpenMenu: (event, id) => OpenMenu(event, id),
          ActiveId,
          menu,
        }}
      />
      <MainTemplateModal
        createNewSite={createNewSite1}
        title={"New site detail"}
        type={"NewSite"}
        HandleCreateSite={HandleCreateSite1}
        AllCategoryList={AllCategoryList}
        updateTemplate={updateTemplate}
        actions={{
          AddSiteDetaill: () => AddSiteDetaill(),
        }}
        innerTemplate={
          <NewSiteDetail
            siteValues={{
              name: (name) => setSiteName(name),
              value: (value) => setSiteId(value),
              siteName,
              siteId,
            }}
          />
        }
      />
      <MainTemplateModal AllCategoryList={AllCategoryList} createNewSite={createNewSite} title={"New site detail"} type={"NewSite"} HandleCreateSite={HandleCreateSite} innerTemplate={<NewSiteDetail />} updateTemplate={updateTemplate}/>
    </>
  );
};

export default CategoryLists;
